<script>
    import { navigate }          from "svelte-routing"
    import { parseDate, erased } from '../../shared/utils.js'
    import * as api              from '../../shared/api.js'
    import Copy                  from '../../shared/Copy.svelte'
    import VCard                 from '../../shared/VCard.svelte'
    import { company, domains }  from '../../shared/stores.js'
    import ConfirmAction         from '../../shared/ConfirmAction.svelte'
    import InquiryTransition     from './InquiryTransition.svelte'
    import ExecutionProgress     from './ExecutionProgress.svelte'
    import Rectify               from './Rectify.svelte'
    import { 
        extractIdentifiers,
        loadInquiry
    } from './inquiry.js'

    export let _protocol = false
    export let _domain  = false
    export let _company = false

    let domain            = null
    let item              = null
    let editkey           = null
    let downloadingReport = false
    let confirmRemove     = false

    if(_domain) {
        domain = $domains.find(it => it.domain === _domain)
    }

    if(_protocol) {
        loadInquiry(_protocol).then(json => item = json).catch(console.error)
    }

    function scopeOf(item) {
        switch(item.inquiry.scope) {
            case 'SAR': return 'Pedido de Acesso'
            case 'DDR': return 'Pedido de Remoção'
            default   : return 'Pedido desconhecido'
        }
    }

    function statusOf(item) {
        if(item) {
            switch(item.inquiry.status) {
                case 'CREATED':
                    return {
                        icon    : 'exclamation triangle',
                        color   : 'yellow',
                        label   : 'Aguardando Identificação',
                        buttons : [{
                            label   : 'Identificar',
                            handler : () => { showIdentifyModal = true }
                        }]
                    }
                case 'IDENTIFIED':
                    return {
                        icon    : 'info circle',
                        color   : '',
                        label   : 'Aguardando Execução',
                        buttons : [{
                            label   : 'Executar',
                            handler : () => { showExecuteModal = true  }
                        }]
                    }
                case 'EXECUTING':
                    return {
                        icon    : 'dolly',
                        color   : 'blue',
                        label   : 'Em Execução',
                        buttons : [{
                            label   : 'Cancelar',
                            handler : () => { alert('NotImplementedYet')  }
                        }, {
                            label   : 'Pausar',
                            handler : () => { alert('NotImplementedYet')  }
                        }]
                    }
                case 'GENERATING REPORT':
                    return {
                        icon    : 'notched circle loading',
                        color   : '',
                        label   : 'Gerando Relatório',
                        buttons : []
                    }
                case 'REPORT SUCCESS':
                    return {
                        icon    : 'check circle',
                        color   : 'green',
                        label   : 'Relatório Finalizado',
                        buttons : []
                    }
                case 'REPORT AVAILABLE':
                    return {
                        icon    : 'error circle',
                        color   : '',
                        label   : 'Relatório Disponível',
                        buttons : []
                    }
                case 'REPORT ERROR':
                    return {
                        icon    : 'error circle',
                        color   : '',
                        label   : 'Erro no Relatório',
                        buttons : []
                    }
                default:
                    return {
                        icon    : 'question circle',
                        color   : 'red',
                        label   : item.inquiry.status,
                        buttons : [{
                            label   : item.inquiry.status,
                            handler : () => { } 
                        }]
                    }
            } 
        }
    }

    function toDashboard() {
        navigate(`/empresa/${domain.company}/pedidos/${domain.domain}`)
    }
    
    function downloadReport() {
        downloadingReport = true
        api .get(`/inquiry/${item.inquiry.protocol}/report`)
            .then(() => downloadingReport = false)
            .catch(() => downloadingReport = false)
    }

    function extractBasic(item) {
        const profile = item.profile.deleted ? erased(item.profile.name) : item.profile.name
        return [
            { key: 'Procolo', value: item.inquiry.protocol           },
            { key: 'Data'   , value: parseDate(item.inquiry.created) },
            { key: 'Estatus', value: status.label                    },
            { key: 'Perfil' , value: profile                         },
        ]
    }

    function extractCookies(item) {
        return [ 
            { key: 'Cookie', value: item.inquiry.real } 
        ]
    }

    function extractKeys(item) {
        return item.keys.map(i => {
            return {
                place : i.place,
                field : i.field, 
                key   : `${i.place.name} / ${i.field.name || i.field.definition}`,
                value : i.value
            }
        })
    }

    function showEditKeyModal(item) {
        editkey = item
    }

    function onRectifyKey(key, value) {
        const data = {
            place: key.place.id,
            field: key.field.id,
            value: value
        }

        return api 
            .post(`/inquiry/${_protocol}/rectify`, data)
            .then(api.toJsonIf200)
            .then(json => {
                editkey    = null
                item       = json
                return json
            })
    }

    function extractProfile(item) {
        return [{
            key   : "Nome",
            value : item && item.profile.name
        }]
    }

    function remove() {
        confirmRemove = false
        return api 
            .del(`/inquiry/${_protocol}`)
            .then(api.toJsonIf200)
            .then(json => {
                toDashboard()
            })
            .catch(e => {
                console.error(`Error removing inquiry ${_protocol}`)
                toDashboard()
            })

    }

    $: status      = statusOf(item)
    $: identifiers = extractIdentifiers(item)
    $: profile     = extractProfile(item)
    $: wanted      = item && item.inquiry.protocol.substring(0, 5)
</script>

<style>

    .content button {
        margin: 8px 0;
    }

    .content .header {
        font-weight: 700;
    }
    .content .header {
        font-size: 1.2em;
        margin-bottom: 1em;
    }
    
    .split {
        font-size: 1em;
        border: 0 !important;    
    }

    .split h3 {
        font-size: 1.2em !important;
        font-weight: 700;
        font-size: 1em;
    }

    .inquiry {
        background-color: #fff;
    }

    .ui.horizontal.segments > .segment:not(.actions) {
        width: 300px;
    } 
</style>

{#if item}
    <div class="inquiry ui segments">
        <div class="ui segment">
            <h2 class="ui header">{ scopeOf(item) }</h2>
            <button class="ui labeled icon button" on:click={ toDashboard }>
                <i class="left arrow icon"></i>
                dashboard
            </button>
            <button class="ui labeled icon red button" on:click={ e => confirmRemove = true }>
                <i class="left trash icon"></i>
                remover
            </button>
        </div>
        <div class="ui segment split">
            <h3>Detalhes</h3>
        </div>
        <div class="ui segments">
            <div class="ui horizontal segments">
                <div class="ui segment">
                    <VCard title="Básicos" items={ extractBasic(item) } />
                </div>
                <div class="ui segment">
                    <div class="content">
                        <VCard title="Perfil"          items={ profile              } />
                        <VCard title="Identificadores" items={ identifiers          } />
                        <VCard title="Chaves"          items={ extractKeys(item)    } edit={item.inquiry.scope == 'SAR'} onEdit={showEditKeyModal}/>
                        <VCard title="Cookies"         items={ extractCookies(item) } />
                    </div>                
                </div>
                <div class="ui segment"> <!-- Transições -->
                    <div class="content">
                        <div class="header">Transições</div>
                        <div class="description">
                            {#each item.inquiry.transitions as transition}
                                <InquiryTransition {item} {transition} />
                            {/each}
                        </div>
                    </div>                
                </div>
                {#if false}
                    <div class="ui actions segment"> <!-- Ações -->
                        <div class="content">
                            <div class="header">Ações</div>
                            <div class="description">
                                {#each status.buttons as button}
                                    <div class="">
                                        <button class="ui small blue button" on:click={ console.log }>{ button.label }</button>
                                    </div>
                                {/each}                                                 
                            </div>
                        </div>                
                    </div>
                {/if}
            </div>
        </div>  
        <div class="ui segment split">
            <h3>Progresso</h3>
        </div>
        <div class="ui segments">
            <ExecutionProgress item={item}/>          
        </div>
    </div>    
{/if}

<Rectify bind:key={editkey} onRectify={onRectifyKey}></Rectify>
<ConfirmAction 
    bind:active={confirmRemove}
    confirm={remove}
    {wanted}></ConfirmAction>


